import { PropsWithChildren } from "react"

import { Stack, StackProps } from "@mui/material"

const BannerLayout = ({
  children,
  sx,
  ...stackProps
}: PropsWithChildren<StackProps>) => {
  return (
    <Stack
      alignItems="center"
      columnGap={2}
      justifyContent="center"
      p={{ xs: "12px", sm: "8px" }}
      borderRadius={"4px"}
      fontSize={{ xs: "14px", sm: "16px" }}
      fontWeight={600}
      sx={{ ...sx }}
      {...stackProps}
    >
      {children}
    </Stack>
  )
}

export default BannerLayout
